import VConsole from "vconsole"

let debugConsole: VConsole | undefined

export const initDebugConsole = (): void => {
  if (
    debugConsole ||
    new URLSearchParams(window.location.search).get("vconsole") !== "1"
  )
    return

  debugConsole = new VConsole()
}
